import { useSeo } from "@/hooks/useSeo";
import Navigation from "@/components/Navigation";
import ProductGrid from "@/components/ProductGrid";
import FeatureStrip from "@/components/FeatureStrip";
import Footer from "@/components/Footer";

const ShopPage = () => {
  useSeo('Shop All Colours | Luxe Lords 10ml Vegan Leather Atomizers', 'Shop all eight colours of Luxe Lords 10ml refillable perfume atomizers in premium vegan leather, £24.95 each.', '/shop');
  return (
    <div className="min-h-screen">
      <Navigation />
      <main className="pt-14 lg:pt-16">
        <FeatureStrip />
        <ProductGrid asPageTitle />
      </main>
      <Footer />
    </div>
  );
};

export default ShopPage;
